import DOMPurify from 'isomorphic-dompurify';

/**
 * Sanitize an HTML string before injecting it via `dangerouslySetInnerHTML`.
 *
 * Message/template/contact bodies in this app are rendered as formatted HTML
 * (paragraphs, mention spans, links, images, line breaks). Some of that markup
 * is derived from data we don't fully control — e.g. a prospect's LinkedIn name
 * or headline interpolated into a preview — so rendering it raw is a stored-XSS
 * sink. This neutralizes scripts and event-handler attributes while preserving
 * the formatting markup the previews rely on.
 *
 * Restricted to the HTML profile (no SVG/MathML vectors). `data-*` and `class`
 * attributes are kept (DOMPurify defaults) because mention/variable/document
 * spans and our Tailwind styling depend on them.
 *
 * Works in the browser and during SSR (isomorphic-dompurify falls back to a
 * server DOM), so it is safe to call from shared components that render on both.
 */
export function sanitizeHtml(html: string | null | undefined): string {
  if (html == null) return '';
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    // Keep target/rel on links rendered inside message bodies.
    ADD_ATTR: ['target', 'rel'],
  });
}
